import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { cx } from 'emotion';
var DEFAULT = 'default';
var LAYOUT = 'layout';
var MINIMAL = 'minimal';

var Card = function Card(_ref) {
  var children = _ref.children,
      header = _ref.header,
      isMinimal = _ref.isMinimal,
      className = _ref.className,
      style = _ref.style,
      type = _ref.type;
  // isMinimal should take priority here for backwards compatibility
  var cardClassName = cx('card', className, {
    'card-minimal': isMinimal || type === MINIMAL,
    'card-layout': !isMinimal && type === LAYOUT
  });
  return React.createElement("div", {
    className: cardClassName,
    style: style
  }, header && React.createElement("div", {
    className: "card-header"
  }, React.createElement("h5", {
    className: "card-title"
  }, header)), React.createElement("div", {
    className: "card-block"
  }, children));
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  isMinimal: PropTypes.bool,
  className: PropTypes.string,
  style: StylePropType,
  type: PropTypes.oneOf([DEFAULT, LAYOUT, MINIMAL])
};
Card.defaultProps = {
  header: undefined,
  isMinimal: false,
  className: '',
  style: {},
  type: DEFAULT
};
export default Card;